// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__vzqPh","tab":"ProcedureTabs_tab__JA_g8"};